import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import { errorToast, successToast } from "../../../utils/toasts";

type Payload = { is_active: boolean; user_id: number };

export const useModifyUserActiveStatusMutation = () => {
  const { t } = useTranslation(["user_management"]);
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (vars: Payload) => {
      const { user_id, is_active } = vars;

      return await apiClient.updateUserActiveStatus({
        user_id,
        is_active,
      });
    },

    onSuccess: () => {
      successToast({
        message: t(($) => $.user_management["User status successfully updated"]),
      });
      void queryClient.invalidateQueries({
        queryKey: [{ entity: "orgUsers" }],
      });
    },
    onError: (error) => {
      errorToast({ message: t(($) => $.user_management["Failed to update user status"]), error });
    },
  });
};
